import styled from "styled-components";

export const RankingWrapper = styled.div`
	.tops {
		margin: 30px 0;
		display: flex;
		background-image: url(${require("@/assets/img/recommend-top-bg.png")});
		height: 472px;
	}
`;
